import React from "react";

export const FilterListItem = ({ checked, id, title, onClick, idPrefix }) => {
  return (
    <label className="checkbox" htmlFor={`eventType-${idPrefix}${id}`}>
      <input
        id={`eventType-${idPrefix}${id}`}
        type="checkbox"
        value={id}
        checked={checked}
        onChange={e => onClick(id, e)}
      />
      <span>{title}</span>
    </label>
  );
};
